import { DataAccess } from "../../../dataaccess/data.access";

/**
 * Bulk contact edits from Connect25 User Search.
 * Uses {@code /run/student-engagement/users/bulk/...}, which always enforces {@code SE_USER_BULK_EDIT} server-side.
 */
export class SeContactBulkEditSeUserService {
    public static putBulkTextComment(contactIds: number[], textComment: string): Promise<unknown> {
        return DataAccess.put(
            DataAccess.injectCaller(
                `/student-engagement/users/bulk/text.json`,
                "SeContactBulkEditSeUserService.putBulkTextComment",
            ),
            {
                text_comment: textComment,
                contacts: contactIds,
            },
        );
    }
}
